import { type HttpAdapter } from "../core/adapters/axios.adapter";

export interface NewsletterDO {
    message: string,
    error?: string
}

export class NewsletterService {
    constructor(private newsletterAdapter: HttpAdapter) { };

    async subscribe(email: string, nlId: string): Promise<NewsletterDO> {
        try {
            if (!nlId) { throw new Error("NlId not provided") }
            const data = email ? { email } : {};

            const response = await this.newsletterAdapter.post(`/${nlId}`, data)
            return response.data
        }
        catch (error: any) {
            throw error
        }
    }
}